/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'searchWhite': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M1 20.999c0 11.022 8.977 19.999 20 19.999 4.791 0 9.196-1.703 12.646-4.527l11.922 11.922c.785.807 2.083.81 2.86.007a2.005 2.005 0 00-.03-2.835L36.476 33.643A19.908 19.908 0 0040.998 21C40.998 9.977 32.021 1 21 1 9.977 1 1 9.977 1 20.999zm20-16c8.859 0 15.998 7.14 15.998 16s-7.14 16-15.999 16c-8.86 0-16-7.14-16-16s7.14-16 16-16z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
